import { deepDestringifyFunctions } from 'smbls'
import { createKvService } from '@symbo.ls/sdk'

const KV_URL = 'https://smbls-kv.nika-980.workers.dev'

const kvService = createKvService({
  options: { kvUrl: KV_URL }
})
kvService.init({ context: { kvUrl: KV_URL } })

export { kvService }

export async function fetchFromKv(key, env = 'production') {
  const result = await kvService.get(key, { env })
  return result.value
}

export function getKvKeyFromUrl() {
  const params = new URLSearchParams(window.location.search)
  const owner = params.get('owner')
  const key = params.get('key')
  if (owner && key) return `${owner}/${key}`
  return null
}

export async function fetchKvProject(key, env = 'production') {
  const data = await fetchFromKv(key, env)
  if (!data) return null
  return typeof data === 'string' ? data : deepDestringifyFunctions(data)
}
